<proffeo-ui-dialog
  [title]="`${('select-parent-task-modal.title' | translate)}: ${taskToMoveName()}`"
  class="relative"
>
  <div
    [proffeoSpinner]="isMoving()"
    proffeoSpinnerSize="lg"
    class="relative flex h-full min-h-0 w-full max-w-full flex-col gap-3 overflow-hidden"
  >
    <mat-form-field
      subscriptSizing="dynamic"
      class="w-full shrink-0"
    >
      <mat-icon
        fontIcon="search"
        matPrefix
      />
      <input
        (input)="onSearchInput($event)"
        [value]="search()"
        [placeholder]="'select-parent-task-modal.search-placeholder' | translate"
        matInput
      />
    </mat-form-field>
    <div class="min-h-0 flex-1 overflow-y-auto">
      <div
        (click)="selectRoot()"
        class="flex h-18 border-b border-proffeo-border cursor-pointer items-center gap-2 p-1 hover:bg-proffeo-surface-muted"
      >
        <mat-radio-button
          [checked]="selectedParentId() === null"
          [disabled]="initialParentId() === null || isMoving()"
          class="w-full"
        >
          {{ 'select-parent-task-modal.no-parent' | translate }}
        </mat-radio-button>
      </div>

      @for (root of rootTasks(); track root.id) {
        <proffeo-select-parent-task-tree-node
          [(expandedIds)]="expandedIds"
          [task]="root"
          [depth]="0"
          [projectId]="dialogData.projectId"
          [forbiddenIds]="forbiddenIds()"
          [selectedParentId]="selectedParentId"
        />
      }
      @if (rootTasks().length === 0) {
        <p class="p-4 text-sm">{{ 'placeholders.no-results-found' | translate }}</p>
      }
    </div>
  </div>

  <div
    dialog-actions
    class="flex w-full items-center justify-end gap-2 py-2"
  >
    <proffeo-ui-button
      [disabled]="isMoving()"
      text="close"
      mat-dialog-close
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="confirmMove()"
      [disabled]="!isChanged() || isMoving()"
      [text]="'select-parent-task-modal.confirm'"
      variant="accent"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
